import { render, staticRenderFns } from "./DepartmentEdit.vue?vue&type=template&id=98c5883c&"
import script from "./DepartmentEdit.vue?vue&type=script&lang=js&"
export * from "./DepartmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DepartmentEdit.vue"
export default component.exports